"use strict";

import "core-js/modules/web.dom-collections.iterator.js";
import { cssLinks } from "@ttark/css-links";
import { buildLegalLoader } from "~/utils/legal-loader";
import { PolicyHead } from "./head";
import { PolicyBody } from "./body";
import { LegalRemixPage } from "~/components/legal-remix-page";
var links = () => [...cssLinks("routes/legal.intellectual-property")];
var loader = buildLegalLoader("legal_policy");
var PolicyPage = class extends LegalRemixPage {
  constructor() {
    super(...arguments);
    this.Head = PolicyHead;
    this.Body = PolicyBody;
  }
};
var clientLoader = async _ref => {
  let {
    serverLoader
  } = _ref;
  const serverData = await serverLoader();
  return serverData;
};
export { clientLoader, PolicyPage as default, links };